import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column parent-container" }
const _hoisted_2 = { class: "nav-bar-layout-container" }
const _hoisted_3 = { class: "flex-grow-1 layout-container chat-container" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "chat-header chat-content align-self-center" }
const _hoisted_6 = { class: "chat-sub-header" }
const _hoisted_7 = ["chat-index"]
const _hoisted_8 = {
  key: 0,
  class: "product-card-chat-container layout-container"
}

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { SharedResponseService } from '@/services/SharedResponseService';
import { v4 as uuidv4 } from 'uuid';

import ProductRepository from '@/repositories/ProductRepository';
import ProductCard from '@/components/ProductCard.vue';
import TaazeNavbar from '@/components/layout/TaazeNavbar.vue';
import ChatMessage from '@/components/ChatMessage.vue'
import Chat from '@/interfaces/Chat';
import Product from '@/models/Product';


export default /*@__PURE__*/_defineComponent({
  __name: 'SharedResponse',
  setup(__props) {

const VERSION = process.env.VUE_APP_VERSION;

const route = useRoute();
const shareId = route.params.shareId;
const sharedResponseService = new SharedResponseService(process.env.VUE_APP_TALK_TO_THE_BOOK_API_URL!);
const productRepository = new ProductRepository(process.env.VUE_APP_TAAZE_API_URL!);

const chatHistory = ref<Chat[]>([]);

let product: Product | null = null;

onMounted(async () => {
  await setup();
});

async function setup() {
  const sharedResponse = await sharedResponseService.getSharedResponseById(String(shareId));

  product = await productRepository.getProductById(sharedResponse.productId);

  chatHistory.value.push(
    {
      id: uuidv4(),
      type: 'user',
      content: sharedResponse.question,
      suggestions: [],
      isLoading: false,
      isGenerating: false
    }
  );

  chatHistory.value.push(
    {
      id: uuidv4(),
      type: 'bot',
      content: sharedResponse.response,
      suggestions: [],
      isLoading: false,
      isGenerating: false
    }
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TaazeNavbar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[0] || (_cache[0] = _createTextVNode("Talk to the books ")),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(VERSION)) + " 版 ", 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatHistory.value, (chat, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            "chat-index": index
          }, [
            _createVNode(ChatMessage, {
              chat: chat,
              "is-prompting-enabled": false,
              "is-share-enabled": false
            }, null, 8, ["chat"])
          ], 8, _hoisted_7))
        }), 128))
      ])
    ]),
    (_unref(product) !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(ProductCard, { product: _unref(product) }, null, 8, ["product"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})